{
  "numbers3": [
    {
      "number": "49%",
      "text": "of white-collar employees consider digital tools provided by their companies to be frustrating."
    },
    {
      "number": "65%",
      "text": "of them believe that they would be more productive if they had access to better technology."
    },
    {
      "number": "25%",
      "text": "consider lack of the right technology as a reason for changing their job."
    }
  ],
  "numbers4": [
    {
      "number": "01.",
      "title": "Customise the offer",
      "text": " Customise the offer to your company’s needs – choose the modules of interest to you"
    },
    {
      "number": "02.",
      "title": "Activate MyBenefit Platform",
      "text": "Activate MyBenefit Platform in your company – take advantage of full support"
    },
    {
      "number": "03.",
      "title": "Measure the results",
      "text": "Measure the results – save the time, reward and motivate"
    }
  ]
}
